import React from 'react'
import PropTypes from 'prop-types'
import {Box, useBreakpointValue, useStyleConfig} from '@chakra-ui/react'

const ImageGalleryDivider = ({customStyles = {}}) => {
    const styles = useStyleConfig('ImageGalleryDivider')
    const dividerType = useBreakpointValue({sm: 'vertical', lg: 'horizontal'})

    const stylesBasedOnType =
        dividerType === 'vertical'
            ? styles?.verticalDefault
            : dividerType === 'horizontal' && styles?.horizontalDefault

    return dividerType && <Box {...stylesBasedOnType} {...customStyles} />
}

ImageGalleryDivider.propTypes = {
    customStyles: PropTypes.object,
}

export default ImageGalleryDivider
